<di-search
           title="Client Company"
           searchPlaceholder="Search"
           [columns]="columns"
           [pageDTO]="pageDTO">

</di-search>